// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-history {
  padding: 24px;
  background: transparent;
  min-height: 100vh;
}
.task-history .ant-statistic .ant-statistic-title {
  color: #64748b;
  font-size: 14px;
  margin-bottom: 8px;
}
.task-history .ant-statistic .ant-statistic-content {
  color: #1e293b;
  font-size: 28px;
  font-weight: 700;
  font-family: 'Outfit', sans-serif;
}
.task-history .ant-statistic .ant-statistic-content-prefix {
  margin-right: 8px;
  font-size: 20px;
}
.task-history .filter-section {
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 24px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: var(--shadow-sm);
}
.task-history .filter-section .ant-row {
  align-items: center;
}
.task-history .filter-section .filter-label {
  margin-right: 8px;
  color: #475569;
  font-weight: 600;
}
.task-history .ant-table {
  background: transparent;
}
.task-history .ant-table .ant-table-container {
  border-radius: 12px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(8px);
}
.task-history .ant-table .ant-table-thead > tr > th {
  background: rgba(248, 250, 252, 0.8);
  font-weight: 600;
  color: #475569;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.task-history .ant-table .ant-table-tbody > tr > td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}
.task-history .ant-table .ant-table-tbody > tr:hover > td {
  background: rgba(255, 255, 255, 0.8) !important;
}
.task-history .ant-table .task-name-cell .task-title {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}
.task-history .ant-table .task-name-cell .task-id {
  font-size: 12px;
  color: #94a3b8;
  font-family: monospace;
}
.task-history .ant-table .files-stats {
  font-size: 12px;
  line-height: 1.4;
}
.task-history .ant-table .files-stats .stat-item {
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.task-history .ant-table .files-stats .stat-item.success {
  color: #10b981;
}
.task-history .ant-table .files-stats .stat-item.failed {
  color: #ef4444;
}
.task-history .ant-table .created-time .time-text {
  margin-bottom: 4px;
  color: #64748b;
}
.task-history .ant-table .created-time .recent-tag {
  margin-top: 4px;
}
.task-history .ant-table .action-buttons .ant-btn {
  margin-right: 4px;
}
.task-history .ant-table .action-buttons .ant-btn:last-child {
  margin-right: 0;
}
.task-history .ant-table .action-buttons .ant-btn.ant-btn-text {
  padding: 4px 8px;
  height: auto;
  line-height: 1.4;
  color: #64748b;
}
.task-history .ant-table .action-buttons .ant-btn.ant-btn-text:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--float-primary);
}
.task-history .ant-table .action-buttons .ant-btn.ant-btn-text .anticon {
  font-size: 14px;
}
.task-history .ant-table .action-buttons .ant-btn.ant-btn-dangerous {
  color: #ef4444;
}
.task-history .ant-table .action-buttons .ant-btn.ant-btn-dangerous:hover {
  color: #dc2626;
  background: rgba(239, 68, 68, 0.1);
}
.task-history .ant-progress .ant-progress-text {
  font-size: 12px;
  color: #64748b;
}
.task-history .ant-progress.ant-progress-status-success .ant-progress-bg {
  background-color: #10b981;
}
.task-history .ant-progress.ant-progress-status-exception .ant-progress-bg {
  background-color: #ef4444;
}
.task-history .ant-tag {
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.4;
  padding: 2px 10px;
  font-weight: 600;
  border: none;
}
.task-history .ant-tag .anticon {
  margin-right: 4px;
}
.task-history .ant-tag.ant-tag-green {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
}
.task-history .ant-tag.ant-tag-blue {
  background: rgba(59, 130, 246, 0.1);
  color: #2563eb;
}
.task-history .ant-tag.ant-tag-red {
  background: rgba(239, 68, 68, 0.1);
  color: #dc2626;
}
.task-history .ant-tag.ant-tag-orange {
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
}
.task-history .ant-modal .ant-modal-content {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(16px);
  border-radius: 16px;
  box-shadow: var(--shadow-xl);
}
.task-history .ant-modal .ant-modal-header {
  background: transparent;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 20px 24px;
}
.task-history .ant-modal .ant-modal-header .ant-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}
.task-history .ant-modal .ant-modal-body {
  padding: 24px;
}
.task-history .ant-modal .ant-descriptions .ant-descriptions-item-label {
  font-weight: 500;
  color: #64748b;
  background: rgba(248, 250, 252, 0.5);
}
.task-history .ant-modal .ant-descriptions .ant-descriptions-item-content {
  color: #334155;
}
.task-history .ant-modal .ant-list .ant-list-item {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: background 0.2s;
  border-radius: 8px;
  margin-bottom: 4px;
}
.task-history .ant-modal .ant-list .ant-list-item:hover {
  background: rgba(255, 255, 255, 0.5);
}
.task-history .ant-modal .ant-list .ant-list-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.task-history .ant-modal .ant-list .ant-list-item .ant-list-item-meta-title {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}
.task-history .ant-modal .ant-list .ant-list-item .ant-list-item-meta-title .file-status {
  float: right;
}
.task-history .ant-modal .ant-list .ant-list-item .ant-list-item-meta-description {
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}
.task-history .ant-modal .ant-list .ant-list-item .ant-list-item-meta-description .error-message {
  color: #ef4444;
  margin-top: 4px;
  font-weight: 500;
}
.task-history .ant-empty {
  padding: 40px 0;
}
.task-history .ant-empty .ant-empty-description {
  color: #94a3b8;
}
.task-history .ant-alert {
  border-radius: 12px;
  margin-bottom: 16px;
  border: none;
}
.task-history .ant-alert.ant-alert-info {
  background: rgba(224, 242, 254, 0.6);
}
.task-history .ant-alert.ant-alert-info .ant-alert-icon {
  color: #0284c7;
}
.task-history .ant-alert.ant-alert-warning {
  background: rgba(254, 252, 232, 0.6);
}
.task-history .ant-alert.ant-alert-warning .ant-alert-icon {
  color: #d97706;
}
.task-history .ant-alert .ant-alert-message {
  font-weight: 600;
  margin-bottom: 4px;
  color: #1e293b;
}
.task-history .ant-alert .ant-alert-description {
  color: #475569;
  font-size: 14px;
}
@media (max-width: 768px) {
  .task-history {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/renderer/components/TaskHistory.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;AACF;AAJA;EAaM,cAAA;EACA,eAAA;EACA,kBAAA;AANN;AATA;EAmBM,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAPN;AAfA;EA0BM,iBAAA;EACA,eAAA;AARN;AAnBA;EAiCI,oCAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,4BAAA;AAXJ;AA5BA;EA0CM,mBAAA;AAXN;AA/BA;EA8CM,iBAAA;EACA,cAAA;EACA,gBAAA;AAZN;AApCA;EAsDI,uBAAA;AAfJ;AAvCA;EAyDM,mBAAA;EACA,gBAAA;EACA,oCAAA;EACA,0BAAA;AAfN;AA7CA;EAgEM,oCAAA;EACA,gBAAA;EACA,cAAA;EACA,4CAAA;AAhBN;AAnDA;EAuEM,4CAAA;AAjBN;AAtDA;EA2EM,+CAAA;AAlBN;AAzDA;EAiFQ,gBAAA;EACA,cAAA;EACA,kBAAA;AArBR;AA9DA;EAuFQ,eAAA;EACA,cAAA;EACA,sBAAA;AAtBR;AAnEA;EA+FM,eAAA;EACA,gBAAA;AAzBN;AAvEA;EAmGQ,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAzBR;AA2BQ;EACE,cAAA;AAzBV;AA4BQ;EACE,cAAA;AA1BV;AAnFA;EAqHQ,kBAAA;EACA,cAAA;AA/BR;AAvFA;EA0HQ,eAAA;AAhCR;AA1FA;EAiIQ,iBAAA;AApCR;AAsCQ;EACE,eAAA;AApCV;AAuCQ;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AArCV;AAuCU;EACE,+BAAA;EACA,2BAAA;AArCZ;AA6BQ;EAYI,eAAA;AAtCZ;AA0CQ;EACE,cAAA;AAxCV;AA0CU;EACE,cAAA;EACA,kCAAA;AAxCZ;AApHA;EAsKM,eAAA;EACA,cAAA;AA/CN;AAkDI;EAEI,yBAAA;AAjDR;AAqDI;EAEI,yBAAA;AApDR;AA9HA;EAyLI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAxDJ;AAtIA;EAiMM,iBAAA;AAxDN;AA2DI;EACE,mCAAA;EACA,cAAA;AAzDN;AA4DI;EACE,mCAAA;EACA,cAAA;AA1DN;AA6DI;EACE,kCAAA;EACA,cAAA;AA3DN;AA8DI;EACE,mCAAA;EACA,cAAA;AA5DN;AAzJA;EA4NM,oCAAA;EACA,2BAAA;EACA,mBAAA;EACA,4BAAA;AAhEN;AA/JA;EAmOM,uBAAA;EACA,4CAAA;EACA,kBAAA;AAjEN;AApKA;EAwOQ,eAAA;EACA,gBAAA;EACA,cAAA;AAjER;AAzKA;EA+OM,aAAA;AAnEN;AA5KA;EAqPQ,gBAAA;EACA,cAAA;EACA,oCAAA;AAtER;AAjLA;EA2PQ,cAAA;AAvER;AApLA;EAkQQ,aAAA;EACA,4CAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;AA3ER;AA6EQ;EACE,oCAAA;AA3EV;AA8EQ;EACE,mBAAA;EACA,gBAAA;AA5EV;AAlMA;EAkRU,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA7EV;AAxMA;EAwRY,YAAA;AA7EZ;AA3MA;EA6RU,cAAA;EACA,eAAA;EACA,gBAAA;AA/EV;AAhNA;EAkSY,cAAA;EACA,eAAA;EACA,gBAAA;AA/EZ;AArNA;EA6SI,eAAA;AArFJ;AAxNA;EAgTM,cAAA;AArFN;AA3NA;EAsTI,mBAAA;EACA,mBAAA;EACA,YAAA;AAxFJ;AA0FI;EACE,oCAAA;AAxFN;AAuFI;EAII,cAAA;AAxFR;AA4FI;EACE,oCAAA;AA1FN;AAyFI;EAII,cAAA;AA1FR;AA5OA;EA2UM,gBAAA;EACA,kBAAA;EACA,cAAA;AA5FN;AAjPA;EAiVM,cAAA;EACA,eAAA;AA7FN;AAkGE;EAAA;IACE,aAAA;EA/FF;AACF","sourcesContent":[".task-history {\n  padding: 24px;\n  background: transparent;\n  min-height: 100vh;\n\n  .ant-card {\n    // Inherit global glass/float styles\n    // But ensure specific overrides needed for this view\n  }\n\n  // 统计卡片样式\n  .ant-statistic {\n    .ant-statistic-title {\n      color: #64748b;\n      font-size: 14px;\n      margin-bottom: 8px;\n    }\n\n    .ant-statistic-content {\n      color: #1e293b;\n      font-size: 28px;\n      font-weight: 700;\n      font-family: 'Outfit', sans-serif;\n    }\n\n    .ant-statistic-content-prefix {\n      margin-right: 8px;\n      font-size: 20px;\n    }\n  }\n\n  // 过滤器区域\n  .filter-section {\n    background: rgba(255, 255, 255, 0.6);\n    backdrop-filter: blur(12px);\n    padding: 16px;\n    border-radius: 12px;\n    margin-bottom: 24px;\n    border: 1px solid rgba(255, 255, 255, 0.5);\n    box-shadow: var(--shadow-sm);\n\n    .ant-row {\n      align-items: center;\n    }\n\n    .filter-label {\n      margin-right: 8px;\n      color: #475569;\n      font-weight: 600;\n    }\n  }\n\n  // 表格样式\n  .ant-table {\n    background: transparent;\n    \n    .ant-table-container {\n      border-radius: 12px;\n      overflow: hidden;\n      background: rgba(255, 255, 255, 0.5);\n      backdrop-filter: blur(8px);\n    }\n\n    .ant-table-thead > tr > th {\n      background: rgba(248, 250, 252, 0.8);\n      font-weight: 600;\n      color: #475569;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n    }\n\n    .ant-table-tbody > tr > td {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.03);\n    }\n\n    .ant-table-tbody > tr:hover > td {\n      background: rgba(255, 255, 255, 0.8) !important;\n    }\n\n    // 任务名称列样式\n    .task-name-cell {\n      .task-title {\n        font-weight: 600;\n        color: #1e293b;\n        margin-bottom: 4px;\n      }\n\n      .task-id {\n        font-size: 12px;\n        color: #94a3b8;\n        font-family: monospace;\n      }\n    }\n\n    // 文件统计列样式\n    .files-stats {\n      font-size: 12px;\n      line-height: 1.4;\n\n      .stat-item {\n        margin-bottom: 2px;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n\n        &.success {\n          color: #10b981;\n        }\n\n        &.failed {\n          color: #ef4444;\n        }\n      }\n    }\n\n    // 创建时间列样式\n    .created-time {\n      .time-text {\n        margin-bottom: 4px;\n        color: #64748b;\n      }\n\n      .recent-tag {\n        margin-top: 4px;\n      }\n    }\n\n    // 操作按钮样式\n    .action-buttons {\n      .ant-btn {\n        margin-right: 4px;\n\n        &:last-child {\n          margin-right: 0;\n        }\n\n        &.ant-btn-text {\n          padding: 4px 8px;\n          height: auto;\n          line-height: 1.4;\n          color: #64748b;\n          \n          &:hover {\n            background: rgba(0, 0, 0, 0.05);\n            color: var(--float-primary);\n          }\n\n          .anticon {\n            font-size: 14px;\n          }\n        }\n\n        &.ant-btn-dangerous {\n          color: #ef4444;\n\n          &:hover {\n            color: #dc2626;\n            background: rgba(239, 68, 68, 0.1);\n          }\n        }\n      }\n    }\n  }\n\n  // 进度条样式\n  .ant-progress {\n    .ant-progress-text {\n      font-size: 12px;\n      color: #64748b;\n    }\n\n    &.ant-progress-status-success {\n      .ant-progress-bg {\n        background-color: #10b981;\n      }\n    }\n\n    &.ant-progress-status-exception {\n      .ant-progress-bg {\n        background-color: #ef4444;\n      }\n    }\n  }\n\n  // 状态标签样式\n  .ant-tag {\n    border-radius: 8px;\n    font-size: 12px;\n    line-height: 1.4;\n    padding: 2px 10px;\n    font-weight: 600;\n    border: none;\n\n    .anticon {\n      margin-right: 4px;\n    }\n\n    &.ant-tag-green {\n      background: rgba(16, 185, 129, 0.1);\n      color: #059669;\n    }\n\n    &.ant-tag-blue {\n      background: rgba(59, 130, 246, 0.1);\n      color: #2563eb;\n    }\n\n    &.ant-tag-red {\n      background: rgba(239, 68, 68, 0.1);\n      color: #dc2626;\n    }\n\n    &.ant-tag-orange {\n      background: rgba(245, 158, 11, 0.1);\n      color: #d97706;\n    }\n  }\n\n  // 模态框样式 - Glass Modal\n  .ant-modal {\n    .ant-modal-content {\n      background: rgba(255, 255, 255, 0.9);\n      backdrop-filter: blur(16px);\n      border-radius: 16px;\n      box-shadow: var(--shadow-xl);\n    }\n    \n    .ant-modal-header {\n      background: transparent;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n      padding: 20px 24px;\n\n      .ant-modal-title {\n        font-size: 18px;\n        font-weight: 600;\n        color: #1e293b;\n      }\n    }\n\n    .ant-modal-body {\n      padding: 24px;\n    }\n\n    // 描述列表样式\n    .ant-descriptions {\n      .ant-descriptions-item-label {\n        font-weight: 500;\n        color: #64748b;\n        background: rgba(248, 250, 252, 0.5);\n      }\n\n      .ant-descriptions-item-content {\n        color: #334155;\n      }\n    }\n\n    // 文件列表样式\n    .ant-list {\n      .ant-list-item {\n        padding: 16px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n        transition: background 0.2s;\n        border-radius: 8px;\n        margin-bottom: 4px;\n\n        &:hover {\n          background: rgba(255, 255, 255, 0.5);\n        }\n\n        &:last-child {\n          border-bottom: none;\n          margin-bottom: 0;\n        }\n\n        .ant-list-item-meta-title {\n          margin-bottom: 8px;\n          font-size: 14px;\n          font-weight: 600;\n          color: #1e293b;\n\n          .file-status {\n            float: right;\n          }\n        }\n\n        .ant-list-item-meta-description {\n          color: #64748b;\n          font-size: 12px;\n          line-height: 1.4;\n\n          .error-message {\n            color: #ef4444;\n            margin-top: 4px;\n            font-weight: 500;\n          }\n        }\n      }\n    }\n  }\n\n  // 空状态样式\n  .ant-empty {\n    padding: 40px 0;\n\n    .ant-empty-description {\n      color: #94a3b8;\n    }\n  }\n\n  // 警告提示样式\n  .ant-alert {\n    border-radius: 12px;\n    margin-bottom: 16px;\n    border: none;\n\n    &.ant-alert-info {\n      background: rgba(224, 242, 254, 0.6);\n      \n      .ant-alert-icon {\n        color: #0284c7;\n      }\n    }\n\n    &.ant-alert-warning {\n      background: rgba(254, 252, 232, 0.6);\n      \n      .ant-alert-icon {\n        color: #d97706;\n      }\n    }\n\n    .ant-alert-message {\n      font-weight: 600;\n      margin-bottom: 4px;\n      color: #1e293b;\n    }\n\n    .ant-alert-description {\n      color: #475569;\n      font-size: 14px;\n    }\n  }\n\n  // 响应式设计\n  @media (max-width: 768px) {\n    padding: 16px;\n    \n    // ... existing mobile styles ...\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
